export default class Address {
  address?: string;
  city?: string;
  complement?: string;
  district?: string;
  ibgeCode?: string;
  id?: number;
  numberAddress?: string;
  principal?: boolean;
  uf?: string;
  zipCode?: string;

  static filledAdress(address: Address): boolean {
    if (
      address.uf != null ||
      address.city != null ||
      address.district != null ||
      address.address != null ||
      address.ibgeCode != null ||
      address.numberAddress != null ||
      address.zipCode != null ||
      address.complement != null ||
      address.uf
    ) {
      return true;
    }
    return false;
  }

  fromJson(address: any) {
    if (!address) return;
    this.id = address.id ?? undefined;
    this.uf = address.uf ?? undefined;
    this.city = address.city ?? undefined;
    this.district = address.district ?? undefined;
    this.address = address.address ?? undefined;
    this.ibgeCode = address.ibgeCode ?? undefined;
    this.numberAddress = address.numberAddress ?? undefined;
    this.zipCode = address.zipCode ?? undefined;
    this.complement = address.complement ?? undefined;
    this.principal = address.principal ?? undefined;
  }

  getAddressDescription() {
    let addressPart = this.address || '';

    if (this.numberAddress) {
      addressPart += `, ${this.numberAddress}`;
    }

    if (this.complement) {
      addressPart += ` (${this.complement})`;
    }

    let locationParts = [];
    if (this.district) locationParts.push(this.district);
    if (this.city) locationParts.push(this.city);
    if (this.uf) locationParts.push(this.uf);
    if (this.zipCode) locationParts.push(this.zipCode);

    let location = locationParts.join(' - ');

    if (!this.numberAddress && !this.complement) {
      if (location) {
        return `${addressPart} - ${location}`;
      }
      return addressPart;
    }

    if (location) {
      return `${addressPart}<br>${location}`;
    }

    return addressPart;
  }

  isDiferent(other: Address | undefined) {
    if (!other || !other.zipCode) return false;
    return (
      other.zipCode !== this.zipCode ||
      other.address !== this.address ||
      other.city !== this.city ||
      other.district !== this.district ||
      other.uf !== this.uf ||
      other.numberAddress !== this.numberAddress
    );
  }
}
